import React from 'react';
import { truncateText } from './truncateText';

/**
 * Text template component with truncation and tooltip
 */
export const TextTemplate: React.FC<{ text?: string; maxLength?: number }> = ({
  text,
  maxLength = 50,
}) => (
  <div title={text || ''}>
    {truncateText(text || '', maxLength)}
  </div>
);

export default TextTemplate;
